// extracted by mini-css-extract-plugin
export var measureBox = "_ba-0";